<cdk-virtual-scroll-viewport itemSize="48" style="height: 200px;">
    <ng-container *cdkVirtualFor="let item of fullDatasource"></ng-container>
  
    <mat-tree *ngIf="fullDatasource.length" [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
        <mat-checkbox [checked]="isSelected(node)" (change)="toggleSelection(node)">
        </mat-checkbox>
        {{node.name}}({{node.id}})
        <button mat-icon-button disabled></button>
      </mat-tree-node>
  
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding ><!--(click)="toggleExpand(node)"-->
        <mat-checkbox [checked]="isSelected(node)" (change)="toggleSelection(node)">
        </mat-checkbox>
        {{node.name}}({{node.id}})
        <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
          <mat-icon class="mat-icon-rtl-mirror">
            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
          </mat-icon>
        </button>
      </mat-tree-node>
    </mat-tree>
  </cdk-virtual-scroll-viewport>
<div *ngIf="selection.selected.length > 0">
    <h3>Elementos seleccionados:</h3>
    <pre>{{ selection.selected | json }}</pre>
</div>